import React from "react";
import PageTitle from "../../../Shared/PageTitle/PageTitle";
import Category from "./components/Category";

import "./BTP.css";

const BTP = () => {
  return (
    <>
      <PageTitle title={"BTP"} currentPage={"BTP"} />
      <Category />
    </>
  );
};

export default BTP;
